import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ConfirmOverlay, ConfirmCard } from './ConfirmModal.styles';

/**
 * Generic confirmation modal (dark overlay style).
 * Render conditionally from the parent — self-contained overlay.
 */
export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  busyLabel,
  danger = true,
  loading = false,
  icon: Icon = AlertTriangle,
  onConfirm,
  onClose,
}) {
  return (
    <ConfirmOverlay onClick={onClose}>
      <ConfirmCard $danger={danger} onClick={e => e.stopPropagation()}>
        <div className="header">
          <div className="icon-wrap">
            <Icon size={16} />
          </div>
          <h3>{title}</h3>
        </div>
        <div className="message">{message}</div>
        <div className="actions">
          <button type="button" className="cancel" onClick={onClose}>
            {cancelLabel}
          </button>
          <button type="button" className="confirm" onClick={onConfirm} disabled={loading}>
            {loading ? busyLabel || `${confirmLabel}...` : confirmLabel}
          </button>
        </div>
      </ConfirmCard>
    </ConfirmOverlay>
  );
}
